export enum EntityPresenterMode {
  Live = 'live',
  Static = 'static',
  LazyLive = 'lazy-live'
}

export function isStaticMode(mode: EntityPresenterMode): boolean {
  return mode === EntityPresenterMode.Static;
}

export function isLiveMode(mode: EntityPresenterMode): boolean {
  return mode === EntityPresenterMode.Live;
}

export function isLazyLiveMode(mode: EntityPresenterMode): boolean {
  return mode === EntityPresenterMode.LazyLive;
}

export function subscribesToEventHub(mode: EntityPresenterMode): boolean {
  return isLiveMode(mode) || isLazyLiveMode(mode);
}

export function isEntityPresenterQueryEnabled({
  mode,
  hasEffectiveId,
  isInViewport,
  lazyLiveUnlocked
}: {
  mode: EntityPresenterMode;
  hasEffectiveId: boolean;
  isInViewport: boolean;
  lazyLiveUnlocked: boolean;
}): boolean {
  if (isStaticMode(mode)) {
    return false;
  }
  if (!hasEffectiveId) {
    return false;
  }
  if (!isInViewport) {
    return false;
  }
  if (isLazyLiveMode(mode) && !lazyLiveUnlocked) {
    return false;
  }
  return true;
}
